import 'react-app-polyfill/ie11';
import '../../styles/global.scss';
import 'fontsource-noto-sans-kr';
import 'bootstrap/dist/css/bootstrap.min.css';

import React from 'react';
// import { useStaticQuery, graphql } from 'gatsby';
import Navigation from './navigation';
import Footer from './footer';

export default ({ children, props }) => {
  // const data = useStaticQuery(
  //   graphql`
  //     query {
  //       site {
  //         siteMetadata {
  //           title
  //         }
  //       }
  //     }
  //   `,
  // );
  return (
    <>
      {/*className="site-wrapper" */}
      <header className="site-header shadow-sm sticky-top py-0">
        <div className="header-wrapper container">
          <Navigation />
        </div>
      </header>

      {children}

      <Footer />
    </>
  );
};
